import { STEP_BASED } from "../constants";

export const toDisplayWeight = (lbs, unit) => unit === "kg" ? +(lbs * 0.453592).toFixed(1) : lbs;
export const toBaseWeight    = (val, unit) => unit === "kg" ? +(val / 0.453592).toFixed(1) : +val;
export const toDisplayDist   = (mi, unit)  => unit === "km" ? +(mi  * 1.60934).toFixed(2)  : mi;
export const toBaseDist      = (val, unit) => unit === "km" ? +(val / 1.60934).toFixed(2)  : +val;
export const weightLabel     = unit => unit === "kg" ? "kg" : "lbs";
export const distLabel       = (cardioType, unit) =>
  STEP_BASED.includes(cardioType) ? "steps" : unit === "km" ? "km" : "mi";
